{
  "hero": {
    "title": "NAPAICP Trust Center",
    "description": "說明平台在安全、隱私、資料處理、可稽核性、可靠性與無障礙上實際採取的作法，只描述系統目前真的具備的行為，不做無法驗證的宣稱。"
  },
  "quickNav": {
    "label": "頁內導覽",
    "security": "安全性",
    "privacy": "隱私",
    "dataHandling": "資料處理",
    "auditability": "可稽核性",
    "reliability": "可靠性",
    "accessibility": "無障礙",
    "incident": "事件聯絡"
  },
  "security": {
    "heading": "安全性",
    "description": "以下措施皆為正式上線使用中的機制，非規劃階段選項。",
    "items": {
      "serverSideAuth": {
        "title": "伺服器端授權",
        "description": "所有身分驗證與權限判斷皆在伺服器端執行，前端顯示或隱藏按鈕不是安全邊界；即使直接呼叫 API，仍會經過相同的授權檢查。"
      },
      "privateStorage": {
        "title": "私有物件儲存",
        "description": "參賽作品檔案存放於私有物件儲存空間，不開放公開存取。"
      },
      "signedUrl": {
        "title": "短效簽名網址",
        "description": "檔案上傳與下載透過效期以分鐘計的簽名網址進行，逾期即失效，且僅限特定操作與物件範圍使用。"
      },
      "passwordHashing": {
        "title": "密碼雜湊儲存",
        "description": "密碼以具版本管理的雜湊演算法儲存，資料庫不保存明文密碼；系統不記錄使用者輸入的原始密碼。"
      },
      "competitionIsolation": {
        "title": "競賽隔離",
        "description": "每場競賽的團隊、作品與角色權限彼此隔離；一場競賽的參與者無法存取另一場競賽的私有資料。"
      },
      "auditTrail": {
        "title": "唯讀且不可竄改的稽核紀錄",
        "description": "權限異動、成績鎖定與帳號治理等高敏感操作會保留操作者、時間與原因；稽核紀錄只提供查詢，不提供刪除或修改。"
      },
      "eventServices": {
        "title": "活動服務的資料保護",
        "description": "活動的乘車憑證只含預約 ID 與簽章，不含個資；乘車行動電話與飲食備註加密儲存，電話只有活動 owner 在緊急聯絡時可查看且每次留紀錄；Email 預約採單次、30 分鐘有效且雜湊儲存的確認連結並受 Turnstile 與節流保護；相關資料於活動結束後自動刪除，保存期限見資料保存政策。"
      }
    }
  },
  "privacy": {
    "heading": "隱私",
    "description": "平台蒐集哪些個資、為何蒐集、誰可以存取、如何申請刪除，完整說明請見隱私權頁面。",
    "cta": "查看隱私權說明"
  },
  "dataHandling": {
    "heading": "資料處理",
    "description": "帳號、競賽、作品與評分等結構化資料與檔案儲存分離存放；各類資料的保存原則與刪除方式，完整說明請見資料保存政策頁面。",
    "cta": "查看資料保存政策"
  },
  "auditability": {
    "heading": "可稽核性",
    "description": "成績計算、鎖定與發布，以及權限授予/撤銷、帳號停權等治理操作，皆會留下操作者、時間、原因與異動內容的紀錄，供主辦方與平台管理員查核。這些紀錄本身不對外公開，僅提供有權限的管理角色查詢。"
  },
  "reliability": {
    "heading": "可靠性",
    "description": "正式環境（Production）與測試環境（Preview）使用彼此隔離的資料庫、檔案儲存與網域，測試環境的操作不會影響正式資料。系統啟動（Bootstrap）與首位管理員帳號的復原程序皆有對應的操作手冊。",
    "deadlineOutage": "若投稿截止時間前發生重大平台故障，管理員可延長該場競賽的截止時間；此操作會產生對應的稽核紀錄，記錄由誰、於何時、基於什麼原因調整。"
  },
  "accessibility": {
    "heading": "無障礙",
    "description": "公開頁面依循 WCAG 2.1 AA 基準設計，包含鍵盤可操作、足夠的色彩對比、可辨識的表單錯誤訊息與響應式版面，支援桌機與行動裝置瀏覽。"
  },
  "incident": {
    "heading": "事件聯絡",
    "description": "若您發現安全性問題、隱私疑慮，或需要協助處理個資相關申請，請透過以下信箱聯絡我們。個別競賽的一般性問題（例如報名或評審流程），建議優先聯絡該場競賽的主辦方。",
    "contactLabel": "安全／隱私聯絡信箱"
  }
}
